import { render, staticRenderFns } from "./DatesSelector.vue?vue&type=template&id=1019ba82"
import script from "./DatesSelector.vue?vue&type=script&lang=js"
export * from "./DatesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports